import { AuthenticationType } from 'azure-maps-control';
var Settings = {
    AZURE_MAPS_OPTIONS: {
        style: "road",
        showLogo: false,
        showFeedbackLink: false,
        authOptions: {
            authType: AuthenticationType.subscriptionKey,
            subscriptionKey: window.maps
        },
        language: "nl-nl",
        dragRotateInteraction: false
        // touchInteraction: false
    }
};
export default Settings;
